import { useQuery } from '@tanstack/react-query';
import { templates } from '@repletoryreach/sdk-api';

/**
 * Templates, refreshed on a timer rather than by realtime.
 *
 * The pages used to call a `useTemplateRealtimeSync` hook that invalidated on
 * `template.*` events, and the page copy promised lifecycle states updating
 * live. The fanout publishes into `tenant:{orgId}` groups and this console's
 * connection joins the platform pseudo-org, so no tenant's template event ever
 * arrived: the subscription cost a connection and delivered nothing. A poll is
 * the honest version until the fanout gains a platform group.
 */
export function useTemplates() {
  return useQuery({
    queryKey: ['templates'],
    queryFn: () => templates.list(),
    staleTime: 30_000,
    refetchInterval: 60_000
  });
}

export function useTemplate(id: string | undefined) {
  return useQuery({
    queryKey: ['templates', id],
    queryFn: () => templates.get(id!),
    enabled: Boolean(id),
    staleTime: 30_000,
    refetchInterval: 60_000
  });
}
